import { FileType, AllowedFileTypes } from "@core/types/file.types";
import { FileUploader } from "@themes/pollinator/ui/FileUploader";

const ALLOWED_FILE_TYPES: AllowedFileTypes = {
  "image/jpeg": true,
  "image/png": true,
  "image/gif": true,
  "image/svg+xml": true,
  "image/webp": true,
};

export type Props = {
  /** Handler for uploading files with progress callback */
  uploadFileHandler: (
    file: File,
    onProgress: (progress: number) => void
  ) => Promise<Partial<FileType>>;
  /** Callback when all files have been processed */
  onAllFilesHandled?: () => void;
  /** Maximum number of files allowed */
  maxFiles?: number;
  /** Callback when upload state changes */
  onUploadStateChange?: (state: { hasFiles: boolean; isAltTextValid: boolean }) => void;
  /** Initial files to display (previously uploaded) */
  initialFiles?: FileType[];
  /** Show remove button for completed files */
  showRemoveButton?: boolean;
  /** Callback when a file is removed */
  onFileRemove?: (fileId: number) => void;
};

/**
 * Logo file uploader component.
 * Accepts image formats only (JPG, PNG, GIF, SVG, WebP).
 */
export function LogosUpload({
  uploadFileHandler,
  onAllFilesHandled,
  maxFiles,
  onUploadStateChange,
  initialFiles,
  showRemoveButton,
  onFileRemove,
}: Props) {
  return (
    <FileUploader
      uploadFileHandler={uploadFileHandler}
      allowedFileTypes={ALLOWED_FILE_TYPES}
      acceptedFileTypes="Images only (JPG, PNG, GIF, SVG, WebP)"
      onAllFilesHandled={onAllFilesHandled}
      maxFiles={maxFiles}
      onUploadStateChange={onUploadStateChange}
      initialFiles={initialFiles}
      showRemoveButton={showRemoveButton}
      onFileRemove={onFileRemove}
      className="w-full"
      data-testid="logos-upload"
    />
  );
}

export default LogosUpload;

